import EmberObject from '@ember/object';

export default class WhyNot extends EmberObject {
  messageId = null;
  value = null;
  additionalMessage = null;
}
